module.exports = __webpack_public_path__ + "img/辛夷.94938d24.jpg";